import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import { useRef } from 'react';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

function detectScrollDirectionAndScrollToBottom(element, callback) {
  let startY = 0;

  element.addEventListener('touchstart', function(event) {
    // 记录触摸起始位置
    startY = event.touches[0].clientY;
  });

  element.addEventListener('touchmove', function(event) {
    const moveY = event.touches[0].clientY;
    const diffY = moveY - startY; // 计算 Y 轴上的移动距离

    // 检查是否滚动到最底部
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;

    // 当前是否在底部
    const isAtBottom = scrollTop + clientHeight >= scrollHeight;

    if (Math.abs(diffY) > 10) {
      // 设置阈值（例如10像素）
      // 如果在最底部，允许向上滑动
      if (isAtBottom && diffY < 0) {
        callback('up'); // 向上滑动
      } else if (diffY > 0) {
        callback('down'); // 向下滑动
      }
    }
  });
}

class NegativeSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  src = IS_MASTER_ENV
    ? `https://mechabreak.seasungames.com/p/m/2024/12/05/pre-dlc/${getLanguageByPath()}/#/`
    : `https://test-zt.xoyo.games/mechabreak.seasungames.com/p/m/2024/12/05/pre-dlc/${getLanguageByPath()}/#/`;
  // src = 'http://test.xoyo.com:5000/iframe-m'; // 本地调试
  @observable isActive = false;

  negativeIframeRef = null;
  onIframeLoad = () => {
    const iframeWin = this.negativeIframeRef.current?.contentWindow;
    const iframeDocument = iframeWin?.document;
    if (iframeDocument) {
      iframeDocument.body?.style.setProperty('overflow', 'hidden auto');
      detectScrollDirectionAndScrollToBottom(iframeDocument.documentElement, direction => {
        if (direction === 'up') {
          this.pageSwiperStore.baseSwiperStore.onChange(1);
        }
      });
    }
  };

  use() {
    this.negativeIframeRef = useRef(null);
    useMount(() => {
      return () => {};
    });
  }
}

export default NegativeSectionStore;
